// @flow

import { backendAxios } from './axios-config';
import isEmpty from 'lodash/isEmpty';
import CustomError from '../utils/error';

const { REACT_APP_WB_BACKEND_URL } = process.env;

const getContributionInfo = (policyId: string, page: number) => {
  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');

  return backendAxios.get(`/policies/${policyId}/contributions?page=${page}`);
};

export default getContributionInfo;
